<div class="separador"></div>

<div class="container">
  <div class="header-section">
    <h1>Liquidaciones</h1>
    <hr />
  </div>

  <div class="action-bar">
    <button class="btn-back" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon> Volver
    </button>
  </div>

  <div class="loading" *ngIf="resul">
    <div class="spinner"></div>
  </div>

  <!-- Desktop Table -->
  <div class="table-container">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      id="tabla"
      class="data-table"
    >
      <thead>
        <tr>
          <th>Año</th>
          <th>Liquidación</th>
          <th>Serie</th>
          <th>Fecha</th>
          <th>Compra</th>
          <th>Cargos</th>
          <th>Descuentos</th>
          <th>APA</th>
          <th>Anticipos</th>
          <th>Base IVA</th>
          <th>Iva</th>
          <th>Base Retención</th>
          <th>Retención</th>
          <th>Imp. Retención</th>
          <th>Bonificación</th>
          <th>Neto</th>
          <th>Total</th>
          <th>Documento</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let dato of datosTabla; index as i"
          [ngClass]="{
            'row-total':
              dato.ttFech === 'TOTALES' || dato.ttFech === 'SIN DATOS'
          }"
        >
          <td>{{ dato.ttEjer }}</td>
          <td>{{ dato.ttLiqu }}</td>
          <td>{{ dato.ttSerie }}</td>
          <td>{{ dato.ttFech }}</td>
          <td class="number">{{ dato.ttCompra | number : ".2" }}</td>
          <td class="number">{{ dato.ttCargos | number : ".2" }}</td>
          <td class="number">{{ dato.ttDtos | number : ".2" }}</td>
          <td class="number">{{ dato.ttApa | number : ".2" }}</td>
          <td class="number">{{ dato.ttAntici | number : ".2" }}</td>
          <td class="number">{{ dato.ttBasiva | number : ".2" }}</td>
          <td class="number">{{ dato.CuoIva | number : ".2" }}</td>
          <td class="number">{{ dato.ttBasRet | number : ".2" }}</td>
          <td class="number">{{ dato.ttRetem | number : ".2" }}</td>
          <td class="number">{{ dato.ttImpRet | number : ".2" }}</td>
          <td class="number">{{ dato.ttBonif | number : ".2" }}</td>
          <td class="number">{{ dato.ttNeto | number : ".2" }}</td>
          <td class="number">{{ dato.ttTotal | number : ".2" }}</td>
          <td>
            <button class="btn-cave" (click)="documento(i)">Descargar</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile Cards -->
  <div class="mobile-cards">
    <div *ngFor="let dato of datosTabla; index as i" class="card-item">
      <div
        class="card-header"
        (click)="
          expandedIndex === i ? (expandedIndex = null) : (expandedIndex = i)
        "
      >
        <div><strong>Año:</strong> {{ dato.ttEjer }}</div>
        <div><strong>Liquidación:</strong> {{ dato.ttLiqu }}</div>
        <div><strong>Serie:</strong> {{ dato.ttSerie }}</div>
        <div class="expand-hint">Toca para ver más...</div>
      </div>

      <div *ngIf="expandedIndex === i" class="card-details">
        <div class="detail-row"><span>Fecha:</span> {{ dato.ttFech }}</div>
        <div class="detail-row">
          <span>Compra:</span> {{ dato.ttCompra | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Cargos:</span> {{ dato.ttCargos | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Descuentos:</span> {{ dato.ttDtos | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>APA:</span> {{ dato.ttApa | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Anticipos:</span> {{ dato.ttAntici | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Base IVA:</span> {{ dato.ttBasiva | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Iva:</span> {{ dato.CuoIva | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Base Retención:</span> {{ dato.ttBasRet | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Retención:</span> {{ dato.ttRetem | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Imp. Retención:</span> {{ dato.ttImpRet | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Bonificación:</span> {{ dato.ttBonif | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Neto:</span> {{ dato.ttNeto | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Total:</span> {{ dato.ttTotal | number : ".2" }}
        </div>
        <div
          class="detail-row"
          style="justify-content: center; margin-top: 1rem"
        >
          <button class="btn-cave" (click)="documento(i)">Descargar</button>
        </div>
      </div>
    </div>
  </div>
</div>
